import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageAccountAction } from '../coverageAccount.action';
import { CoverageAccountTranslator } from '../coverageAccount.translator';

type IDependencies = ICoverageApiDependencySegment;

export const updateCoverageAccountEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageAccountAction.update.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return coverageApi
      .updateCoverageAccount(payload.serverId, payload.reportId, payload.accountId, CoverageAccountTranslator.toApi(payload))
      .pipe(
        mergeMap(() => {
          resolve(payload.accountId);
          return [CoverageAccountAction.update.done({ params })];
        }),
        catchApiError((error) => [
          CoverageAccountAction.update.failed({ params, error }),
          createApiErrorNotification(error),
        ]),
      );
  }),
);
